
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"512pt","viewBox":"0 -32 512 512","width":"512pt","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M298.668 106.668c0 58.91-47.758 106.664-106.668 106.664S85.332 165.578 85.332 106.668C85.332 47.758 133.09 0 192 0s106.668 47.758 106.668 106.668zm0 0M282.668 256H101.332C45.461 256 0 301.46 0 357.332V432c0 8.832 7.168 16 16 16h352c8.832 0 16-7.168 16-16v-74.668C384 301.461 338.54 256 282.668 256zm0 0M506.902 180.266l-74.668-69.332c-3.007-2.797-6.933-4.246-10.879-4.246-10.582 0-16.023 9.003-16.023 15.98v48H320c-11.797 0-21.332 9.555-21.332 21.332s9.535 21.332 21.332 21.332h85.332v48c0 8.875 7.211 16 16 16a16.05 16.05 0 0010.902-4.266l74.668-69.332c3.243-3.03 5.098-7.296 5.098-11.734s-1.855-8.703-5.098-11.734zm0 0"}})])
          )
        }
      }
    